import {
  appConfig,
  appRun,
  AppComponent,
  dependencies
} from './app.imports';

// Modules
import vacationsAbsencesModule from './vacations-absences.module/vacations-absences.module';
import foodBenefitModule from './food-benefit.module/food-benefit.module';
import loansModule from './loans.module/loans.module';
import solidarity from './solidarity.module/solidarity.module';
import socialSecurity from './social-security.module/social-security.module';

import mobileModule from './mobile/mobile.module';

// App launch
angular

  .module('app', dependencies.concat([
    vacationsAbsencesModule,
    foodBenefitModule,
    loansModule,
    solidarity,
    socialSecurity,
    mobileModule
  ]))

  .config(appConfig)

  .run(appRun)

  .value('entryPoint', null)

  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js